import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { useInputPaddings } from '../../InputGroup.mjs';
import { inputClassNameBase } from '../../_common.mjs';
import { jsx } from 'react/jsx-runtime';

const SelectInputButtonInput = /*#__PURE__*/forwardRef(function ButtonInput({
  size = 'md',
  className,
  style,
  ...restProps
}, ref) {
  const inputPaddings = useInputPaddings();
  return /*#__PURE__*/jsx("button", {
    ref: ref,
    type: "button",
    className: clsx(inputClassNameBase({
      size
    }), 'np-button-input', className),
    style: {
      ...inputPaddings,
      ...style
    },
    ...restProps
  });
});

export { SelectInputButtonInput };
//# sourceMappingURL=SelectInputButtonInput.mjs.map
